module.exports = __webpack_public_path__ + "static/media/admin-card-img.483e19bb.png";